import React, {Component} from 'react';
import {Button, Tooltip, Icon} from 'antd';

export default function(props) {
  return <Tooltip title={props.tooltip}>
    <Icon style={Object.assign({marginLeft:10, lineHeight:'20px', cursor:'pointer'}, props.style)} type="question-circle" />
  </Tooltip>;
}



// WEBPACK FOOTER //
// ./src/components/Common/GuideTip.js